import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { scoutChatCenterServerUrl } from '../autoConfig';
import { Widget } from './Widget';
import AppHeader from '../Component/Header';
import AppMenu from '../Component/Menu';
import axios from 'axios';
import { Layout } from 'antd';
import { useMsal } from '@azure/msal-react';
const { Sider, Content } = Layout;

const Chat = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [collapsed, setCollapsed] = useState(true);

  const { instance } = useMsal();
  const signOut = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/chatSession/removeSSE?consultantEmail=${name}`
      });
      localStorage.removeItem('username');
      instance.logout();
      window.location.href = '/';
      return response;
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };

  const getConversationId = async (email) => {
    try {
      const response = await axios({
        method: 'get',
        url: `https://scout-global-app.azurewebsites.net/user/findUserByEmail/${email}`
      });
      sessionStorage.setItem('teamsID', response.data.conversationId);
      sessionStorage.setItem('consultantCountry', response.data?.country);
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  const onClick = (e) => {
    if (e.key === '1') {
      window.location.href = '/chat';
    }
    if (e.key === '2') {
      navigate('/team');
      //   window.location.href = '/team';
    }
    if (e.key === '3') {
      navigate('/history');
      //   window.location.href = '/history';
    }
  };

  const capitalizeName = (email) => {
    return (
      email
        .split('@')[0] // Split the email at '@' and take the first part
        .split('.') // Split by '.' to separate first and last names
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1)) // Capitalize the first character of each part
        .join('.') +
      '@' +
      email.split('@')[1]
    ); // Join the parts back with '.' and append the domain
  };

  useEffect(() => {
    localStorage.getItem('username') &&
      setName(JSON.parse(localStorage.getItem('username'))[0].value);
    sessionStorage.getItem('role') && setRole(sessionStorage.getItem('role'));
  }, []);

  useEffect(() => {
    if (localStorage.getItem('username') === null) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    name && getConversationId(capitalizeName(name));
  }, [name]);

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <AppMenu activeKey={'1'} onClick={onClick} role={role} />
      </Sider>
      <Layout>
        <AppHeader
          name={name}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          signOut={signOut}
        />
        <Content className="h-[calc(100vh-64px)] flex">
          <div className="m-4 w-full drop-shadow-md">
            <Widget />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Chat;
